<template>
  <v-data-table
    :items="getFilteredWasteCauses"
    :headers="headers"
    :loading="loading"
    :search="search"
    :mobile-breakpoint="0"
    sort-by="name"
    @page-count="pageCount = $event"
    :page.sync="page"
    hide-default-footer
  >
    <template v-slot:item.actions="{ item }">
      <v-row align="center" justify="end" no-gutters v-if="getIsAdmin">
        <Prompt
          v-if="getIsAdmin"
          activator-icon="far fa-edit"
          :activatorIconSize="$vuetify.breakpoint.xsOnly ? 'small' : 'medium'"
          inputText="Modifier la raison"
          errorMessage="Une raison est requise"
          text
          @submit="v => editCause(v, item)"
        >
        </Prompt>
        <Prompt
          type="confirm"
          v-if="getIsAdmin"
          :activator-icon="item.is_deleted ? 'fa-trash-restore' : 'fa-trash'"
          :activatorIconSize="$vuetify.breakpoint.xsOnly ? 'small' : 'medium'"
          inputText="Supprimer la raison?"
          submitText="Supprimer"
          submitColor="error"
          text
          @submit="v => toggleDeleteCause(v, item)"
        >
        </Prompt>
      </v-row>
    </template>
    <template v-slot:item.name="{ item }">
      <span class="font-weight-bold">{{ item.name }}</span>
    </template>
    <template v-slot:top>
      <v-row align="center" justify="end" dense>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            filled
            hide-details
            single-line
            clearable
            prepend-inner-icon="fa-search"
            v-model="search"
            class="no-before"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <template v-slot:footer>
      <v-pagination
        color="accent"
        v-model="page"
        :length="pageCount"
        :total-visible="5"
      ></v-pagination>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@/api";
export default {
  name: "InventoryWasteGrid",
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getWasteCauses", "getIsAdmin", "getStoreId"]),
    getFilteredWasteCauses() {
      return this.showDeleted
        ? this.getWasteCauses
        : this.getWasteCauses.filter(x => x.is_deleted === false);
    }
  },
  data() {
    return {
      headers: [
        { value: "name", text: "Raison" },
        { value: "actions", text: "" }
      ],
      showDeleted: false,
      search: null,
      page: 1,
      pageCount: 0
    };
  },
  methods: {
    async editCause(name, item) {
      if (name) {
        try {
          this.$store.dispatch("slo");
          const data = {
            ...item,
            name: name
          };
          await api.patchInventoryWasteCause(data);
          this.$store.dispatch("loadWasteCauses", {
            store: this.getStoreId
          });
        } finally {
          this.$store.dispatch("elo");
        }
      }
    },
    async toggleDeleteCause(res, item) {
      if (res === true) {
        try {
          this.$store.dispatch("slo");
          const data = {
            ...item,
            is_deleted: !item.is_deleted
          };
          await api.patchInventoryWasteCause(data);
          this.$store.dispatch("loadWasteCauses", {
            store: this.getStoreId
          });
        } finally {
          this.$store.dispatch("elo");
        }
      }
    }
  }
};
</script>

<style></style>
